module.exports = __webpack_public_path__ + "static/media/t-8-q-8.2434c78b.jpg";